export default __webpack_public_path__ + "static/media/client7.1359a1a6.jpg";